import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { DemandSettingDataModel, UpdateResult } from "../../../models";

import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CircularProgress from '@mui/material/CircularProgress';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import SelectDemandSettingDataDialog_TJ360DeviceVersion from '../../dialogs/SelectDemandSettingDataDialog_TJ360DeviceVersion';
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const NO_OF_POLLING_TOPIC = 2;

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isEdit: false,
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    deviceNo:"",
    centralId:"",
    isRefreshAllCompleted: (status: number) => { },
    setIsEdit: (isEdit: boolean) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
}

type DemandSettingData_TJ360VersionDeviceProps = {
    defaultData: DemandSettingDataModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureDemandSettingData_TJ360VersionDeviceProps = DemandSettingData_TJ360VersionDeviceProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "DEMAND_SETTING_DATA_FETCH";
export const DemandSettingData_TJ360VersionDevice = (props: PureDemandSettingData_TJ360VersionDeviceProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, deviceNo, centralId, isRefreshSuccessDeviceNo } = props;
    const { onError, onUpdate, onRefresh, onUpdateSuccess, onUpdateError, isRefreshAllCompleted, setIsEdit, setDisabledRefreshGroupBtn, setRefreshGroup } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [demandSettingData, setDemandSettingData] = React.useState<DemandSettingDataModel|null>(props.fetchState.data);
    const [editFlg, setEditFlg] = React.useState(false);
    const [updateLoading, setUpdateLoading] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);
    
    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PB";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    const formatPulseCoefficient = (pulseCoefficient: string | undefined) => {
        if (!pulseCoefficient) return '';
        const start = Number(pulseCoefficient.substring(0, 4));
        const end = "." + pulseCoefficient.substring(4, 8);
        return start + end;
    }

    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setUpdateLoading(false);
        setEditFlg(false);
        const resData = {
            mainid: data.mainid,
            alarm2Kw: data.alarm2_kw,
            alarm1Kw: data.alarm1_kw,
            pulseCoefficient: data.pulse_coefficient,
            demandTstop: data.demand_tstop,
            alarm2Recovery: data.alarm2_recovery,
            alarm1Recovery: data.alarm1_recovery,
            lastGetDatetime: data.last_get_datetime,
        } as DemandSettingDataModel;
        setDemandSettingData(resData);
        action === "edit" && setOpenSelectDialog(true);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setEditFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        const params = handleFetchParams();
        setIsRefreshSuccess(false);
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        props.onRefreshComplete?.();
    }

    const handleEdit = () => {
        setEditFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleUpdateOk = (request: any) => {
        setOpenSelectDialog(false);
        setUpdateLoading(true);
        const code = "PC";
        const requestData = {
            mainid: request.mainid,
            device_no: deviceNo,
            centralid: centralId,
            alarm2_kw: request.alarm2_kw,
            alarm1_kw: request.alarm1_kw,
            pulse_coefficient: request.pulse_coefficient,
            demand_tstop: request.demand_tstop,
            alarm2_recovery: request?.alarm2_recovery,
            alarm1_recovery: request?.alarm1_recovery,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        setIsRefreshSuccess(false);
    };

    const handleUpdateCancel = () => {
        setOpenSelectDialog(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            onUpdateSuccess();
            handleFetchSuccess(updateData, 'view', true);
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        onUpdateError(success, data, error);
        setUpdateLoading(false);
        setEditFlg(false);
        setIsRefreshSuccess(true);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setIsEdit(editFlg);
        // eslint-disable-next-line
    }, [editFlg]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(fetchState.loading || updateLoading, fetchId);
        // eslint-disable-next-line
    }, [updateLoading, fetchState.loading]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setDemandSettingData(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={() => handleEdit()} disabled={isDisbleUpdateBtn || isEdit || fetchState.loading || updateLoading || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit || fetchState.loading || updateLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || editFlg || fetchState.loading || updateLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg || fetchState.loading || updateLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='デマンド設定値'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] || updateLoading) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>限界電力</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>注意電力</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>パルス係数</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>デマンド未判定時限</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>限界警報復帰</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>注意警報復帰</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>限界電力</td>
                                    <td style={pollingColStyle}>{demandSettingData?.alarm2Kw}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>注意電力</td>
                                    <td style={pollingColStyle}>{demandSettingData?.alarm1Kw}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>パルス係数</td>
                                    <td style={pollingColStyle}>{formatPulseCoefficient(demandSettingData?.pulseCoefficient)}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>デマンド未判定時限</td>
                                    <td style={pollingColStyle}>{demandSettingData?.demandTstop}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>限界警報復帰</td>
                                    <td style={pollingColStyle}>{demandSettingData?.alarm2Recovery}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>注意警報復帰</td>
                                    <td style={pollingColStyle}>{demandSettingData?.alarm1Recovery}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{demandSettingData?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            {
                openSelectDialog ? (
                    <SelectDemandSettingDataDialog_TJ360DeviceVersion
                        isOpen={true}
                        onOK={(data) => handleUpdateOk(data)}
                        onCancel={handleUpdateCancel}
                        data={{ ...demandSettingData }}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId="UPDATE_DEMAND_SETTING_DATA" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_DEMAND_SETTING_DATA", `/polling-nrf/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド設定値取得",
            body: "デマンド設定値取得できません。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: "デマンド設定値変更",
            body: "デマンド設定値を更新しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド設定値変更",
            body: "デマンド設定値を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DemandSettingData_TJ360VersionDevice);



